var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkloadSecurity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6207 40.0566C55.3255 39.6154 59 35.8659 59 31.3057C59 27.2382 56.0765 23.8157 52.1061 22.8106C52.4886 21.8999 52.7 20.8997 52.7 19.85C52.7 15.625 49.275 12.2 45.05 12.2C43.3204 12.2 41.7248 12.774 40.4434 13.742C38.4491 10.1392 34.6094 7.70001 30.2 7.70001C24.265 7.70001 19.3622 12.1191 18.6023 17.8463C17.8436 17.6849 17.0567 17.6 16.25 17.6C10.0368 17.6 5 22.6368 5 28.85C5 35.0632 10.0368 40.1 16.25 40.1C16.5371 40.1 16.8217 40.0893 17.1034 40.0681V40.1H49.6772C49.6814 40.1 49.6855 40.1 49.6896 40.1C49.6938 40.1 49.6979 40.1 49.702 40.1H50.6207V40.0566Z",
    fill: "#D6E4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8486 19.4C40.8486 19.4 35.0437 28.5263 24.1187 24.8751C24.1187 24.8751 20.6992 49.3849 40.899 56.3L40.9999 56.2269V19.6193C40.899 19.4804 40.8486 19.4 40.8486 19.4Z",
    fill: "#6690FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8918 25.2206C47.9717 28.5421 42.0787 20.7957 41 19.4L41.0437 56.3C61.2446 49.3831 57.8918 25.2206 57.8918 25.2206Z",
    fill: "#84A9FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0904 26.2817C57.0201 25.3603 56.1038 24.8084 55.2005 25.0029C48.6944 26.4038 44.4276 22.9583 42.3386 20.5655C41.5842 19.7014 40.017 19.661 39.2318 20.4972C36.9874 22.8876 32.4234 26.4044 25.8355 25.0126C24.915 24.8181 23.9872 25.3944 23.9424 26.3341C23.6724 31.9923 24.2111 49.4165 40.3402 55.2291C40.6505 55.341 41.0073 55.3409 41.3177 55.229C57.4875 49.401 57.5176 31.8843 57.0904 26.2817Z",
    stroke: "#3366FF",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkloadSecurity);
export default __webpack_public_path__ + "static/media/workloadSecurity.64c21aaefb9e9e23590259842ec01361.svg";
export { ForwardRef as ReactComponent };